import { render } from "./UserEdit.vue?vue&type=template&id=c990215a&scoped=true"
import script from "./UserEdit.vue?vue&type=script&lang=js"
export * from "./UserEdit.vue?vue&type=script&lang=js"

import "./UserEdit.vue?vue&type=style&index=0&id=c990215a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c990215a"]])

export default __exports__